import { getHostname } from '@gls-its-frontends/common/gls-app-config';
import { glsReportCustomDynatraceError } from '@gls-its-frontends/common/gls-dynatrace';
import { ENVIRONMENT_HOSTNAMES } from '../constants/environment-hostnames';
import { Environment } from '../enums/environment';

const getEnvironment = (): Environment => {
    switch (getHostname()) {
        case ENVIRONMENT_HOSTNAMES[Environment.LOCAL]:
            return Environment.LOCAL;
        case ENVIRONMENT_HOSTNAMES[Environment.DEV]:
            return Environment.DEV;
        case ENVIRONMENT_HOSTNAMES[Environment.STAGE]:
            return Environment.STAGE;
        case ENVIRONMENT_HOSTNAMES[Environment.PROD]:
            return Environment.PROD;
        default:
            glsReportCustomDynatraceError('Unknown environment hostname', getHostname());

            return Environment.DEV;
    }
};

export { getEnvironment };
